// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"412":"951e2795","453":"7e24c6eb","841":"53b25c08","964":"6a900728"}[chunkId] + ".chunk.js");